import React, { useState } from "react";
import { Accordion } from "react-bootstrap";

const FilterDropdown = ({ filters, setFilters, onApply, setShowFilter, allFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (key, value) => {
    if (localFilters?.[key]?.includes(value)) {
      setLocalFilters((prev) => ({
        ...prev,
        [key]: prev[key].filter((v) => v !== value),
      }));
    } else {
      setLocalFilters((prev) => ({
        ...prev,
        [key]: [...(prev[key] || []), value],
      }));

    }
  };

  const handleClear = () => {
    setLocalFilters({});
    setFilters({});
    setShowFilter?.(false);
  };

  const handleApply = () => {
    setFilters(localFilters);
    onApply && onApply(localFilters);
    setShowFilter?.(false);
  };

  return (
    <div
      className="dropdown-menu filter-options"
      aria-labelledby="dropdownMenuButton2"
    >
      <h4>Filter By</h4>

      <Accordion flush>
        {Object.keys(allFilters).map((key, index) => (
          <React.Fragment key={index}>
            {allFilters[key]?.length ? (
              <Accordion.Item className="card" eventKey={index.toString()}>
                <Accordion.Header className="card-header">
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </Accordion.Header>
                <Accordion.Body className="card-body">
                  <ul>
                    {allFilters[key].map((opt, optIndex) => (
                      <li key={optIndex}>
                        <label className="select-multiple-option">
                          <input
                            type="checkbox"
                            id={`custom-checkbox-${key}-${optIndex}`}
                            value={opt}
                            name={key}
                            checked={localFilters[key]?.includes(opt)}
                            onChange={() => handleChange(key, opt)}
                          />
                          {opt}
                          <span className="checkmark"></span>
                        </label>
                      </li>
                    ))}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            ) : null}
          </React.Fragment>
        ))}
      </Accordion>

      <div className="filter-footer">
        <button className="btn btn-primary btn-bordered" onClick={handleClear}>
          Clear
        </button>
        <button className="btn btn-primary btn-filled" onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default FilterDropdown;
